var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "help" } }, [
    _c(
      "div",
      { staticClass: "help-warp" },
      [
        _c("p", { staticClass: "help-warp-search" }, [
          _vm._v("搜索“"),
          _c("span", { staticClass: "red" }, [_vm._v(_vm._s(_vm.thisKey))]),
          _vm._v("”的相关结果，共" + _vm._s(_vm.maxCount) + "条")
        ]),
        _c(
          "ul",
          { staticClass: "help-type-list" },
          _vm._l(_vm.helpList, function(item) {
            return _c(
              "li",
              { key: item.id },
              [
                _c(
                  "nuxt-link",
                  { attrs: { to: "/trait/help/detail/" + item.id } },
                  [_vm._v(_vm._s(item.problem_title))]
                ),
                _c("p", [
                  _c("span", [_vm._v(_vm._s(item.update_time) + " ")]),
                  _c("span", [
                    _c("i", { staticClass: "el-icon-view" }),
                    _vm._v(_vm._s(item.view_num) + " ")
                  ])
                ])
              ],
              1
            )
          }),
          0
        ),
        _c("el-pagination", {
          attrs: {
            layout: "prev, pager, next",
            "page-size": 20,
            total: _vm.maxCount
          },
          on: { "current-change": _vm.currentChange }
        })
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-b8372fe8", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// /opt/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b8372fe8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!/opt/node_modules/vue-loader/lib/selector.js?type=template&index=0!./pages/trait/help/search.vue
// module id = 0h4Y
// module chunks = 4